import getFieldValue from '../form_wizard/elements/getFieldValue';
import getForm from '../form_wizard/elements/getForm';
import getClientId from '../storage/getClientId';
import getVisitorId from '../storage/getVisitorId';
import { trackFormWizardEvent } from './track_form_wizard_event';

export default function (element) {
  const leadFormStartEventExists = (dataLayer, formVersion) => {
    return dataLayer.some(
      (item) =>
        item.event === 'lead_form_start' && item.leadform_id === formVersion
    );
  };
  const form = getForm(element);
  const formVersion = getFieldValue(form, 'leadform');
  window.dataLayer = window.dataLayer || [];
  const eventExists = leadFormStartEventExists(window.dataLayer, formVersion);
  if (eventExists) return;

  trackFormWizardEvent(element, {
    category: 'form_wizard_start',
    action: 'formWizard_start',
  });

  window.dataLayer.push({
    event: 'lead_form_start',
    contents: element.innerText ? element.innerText.trim() : '',
    leadform_id: formVersion,
    visitor_id: getVisitorId(),
    client_id: getClientId(),
  });
}
